interface ReplyPlaygroundButtonProps {
  disabled?: boolean;
  onClick?: () => void;
}

export const ReplyPlaygroundButton = ({
  disabled = false,
  onClick = () => {},
}: ReplyPlaygroundButtonProps) => {
  return (
    <button
      disabled={disabled}
      className={'group/button disabled:opacity-30 absolute bottom-5 right-3.5'}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="18"
        viewBox="0 0 24 18"
        fill="none"
      >
        <path
          d="M0 18V11.25L10.1053 9L0 6.75V0L24 9L0 18Z"
          fill="#7A6BE5"
          className={'group-hover/button:fill-[#564BA5]'}
        />
      </svg>
    </button>
  );
};
